import { FC } from 'react'
import { UserTransactions } from '../UserProfile/UserTransactions'
import {
  // Accounts,
  ToggleButtons,
} from './Accounts'
import { Commissions } from './Commissions'
import { Finance } from './Finance/Finance'

export type componentName = string

export interface ITabList {
  tabLabel: string
  slug: string
  component: FC
}

export const tabList: ITabList[] = [
  {
    tabLabel: 'Finance',
    slug: 'finance',
    component: Finance,
  },
  {
    tabLabel: 'Transactions',
    slug: 'transactions',
    component: UserTransactions,
  },
  {
    tabLabel: 'Commissions',
    slug: 'commissions',
    component: Commissions,
  },
  {
    tabLabel: 'Accounts',
    slug: 'accounts',
    // component: Accounts,
    component: ToggleButtons,
  },
]
